export function parseQs(data: any) {
  return `${encodeURI(JSON.stringify(data))}`;
}
